"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _finance = require("@/api/finance");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _addRemark = _interopRequireDefault(require("./addRemark"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['orderId', 'whichPeriod'],
  components: {
    customPage: _customPage.default,
    addDialog: _addRemark.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      total: 0
    };
  },
  methods: {
    add: function add() {
      this.$refs.addDialog.dialogVisible = true;
    },
    getList: function getList() {
      var _this = this;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _finance.getOrderRemark)({
        page: page,
        pageSize: pageSize,
        orderId: this.orderId
      }).then(function (res) {
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this2 = this;
      if (val) {
        this.$nextTick(function () {
          _this2.getList();
        });
      }
    }
  }
};
exports.default = _default;